/**
 * Helper function to combine signal groups from allSignalGroups and resources
 *
 * @param allSignalGroups - Array of signal groups from data.allSignalGroups
 * @param resources - Resources object containing signalGroupsByID fields
 * @returns Combined array of unique signal groups (unique by identifier field)
 */
export function combineSignalGroups(allSignalGroups: any[], resources: { [key: string]: any }): any[] {
  const signalGroupsMap = new Map<string, any>()
  const groupId = (group: any) => group.identifier + '-' + group.verdict.threatLevel

  allSignalGroups.forEach((group) => signalGroupsMap.set(groupId(group), group))

  // Extract and add signal groups from resources
  const resourceSignalGroups = Object.values(resources ?? {})
    .flatMap((resource) => Object.values(resource?.signalGroupsByID ?? {}))
    .filter((group: any) => group?.identifier && !signalGroupsMap.has(groupId(group)))

  resourceSignalGroups.forEach((group: any) => signalGroupsMap.set(groupId(group), group))

  return Array.from(signalGroupsMap.values())
}
